import styled from 'styled-components';
import COLORS from '../../colors';

const DetailsParentRoot = styled.div<{ isDisabled?: boolean }>`
  width: 100%;
  position: relative;
  border-radius: 16px;
  background-color: ${(props) =>
    props.isDisabled ? COLORS.DROPDOWN_GREY : COLORS.NEUTRAL_925};
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'auto')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 16px;
  box-sizing: border-box;
  gap: 12px;
  text-align: left;
  font-size: 27.65px;
  color: ${COLORS.WHITE};
  margin-top: 16px;
  margin-bottom: 16px;
`;

const ContentContainer = ({ children, className, isDisabled = false }: any) => {
  return (
    <DetailsParentRoot isDisabled={isDisabled} className={className}>
      {children}
    </DetailsParentRoot>
  );
};

export default ContentContainer;
